<template>
    <div id="download" class="pt-12 pb-12 w-full text-center">
        <h1 class="text-main-black font-semibold text-2xl">Download Our App</h1>
        <div class="mt-4 opacity-50 text-sm md:block xs:hidden">
            Unlock a world of possibilities for your health and wellness. Dive deeper, achieve more, and embrace a better version of yourself.
        </div>
        <div>
            <a href="https://apps.apple.com/us/app/luyao/id6472626683"> <img src="./../assets/app-store.svg" alt="" class="h-32 mr-6"></a>
            <a href="https://play.google.com/store/apps/details?id=com.ruyicode.luyao" target="_blank"> <img src="./../assets/google-play.svg" alt="" class="h-32"></a>
        </div>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style scoped>

</style>